module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0148.jpg?v=b42be7c9";